export default class ArticleCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-article-card', ArticleCard);
